import React, { FunctionComponent } from 'react';
import HanPagination from '../../../utils/HanPagination';

interface Props {
    pageCount: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    total: number;

    children: any;
}

const FilterPageFooter: FunctionComponent<Props> = ({ pageCount, currentPage, onPageChange, total, children }) => {

    return (
        <React.Fragment>
            <div className={'filter-page__page-button'}>
                { children }
            </div>

            { total > 0 &&
                <HanPagination
                    pageCount={pageCount}
                    currentPage={currentPage}
                    onPageChange={onPageChange} />
            }
        </React.Fragment>
    );
};

export default FilterPageFooter;
